<template>
    <img @click="$emit('click', $event)" :src="icon['1x']" :srcset="`${icon['1x']} 1x, ${icon['2x']} 2x, ${icon['3x']} 3x`" alt="">
</template>

<script>

import icons from './icons'

export default {
    name: 'Icon',
    props: {
        name: {
            required: true,
            type: String
        },
        type: {

        }
    },
    computed: {
        icon () {
            return icons[this.name][this.type === undefined ? 'default' : this.type]
        }
    }
}
</script>

<style scoped>

</style>
